import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { TokenStorageService } from 'src/app/shared/service/token-storage.service';
import { UserStatus } from '../enum/user-status';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private session: TokenStorageService, private router: Router) {}

  canActivate(): boolean {
    const auth = this.session.getAuth();

    if (auth?.token && auth.status === UserStatus.AUTHENTICATED) {
      this.router.navigate(['/']);
      return false;
    }

    return true;
  }
}
